import { useEffect, useState } from "react";
import FilterTable from "../../../components/FilterTable";
import PageHeading from "../../../components/PageHeading";
import { Link } from "react-router-dom";
import GetInvestorOverviewDetails from "../../../APIs/InvestorPortfolio/GetInvestorOverviewDetails";
import Loader from "../../../components/Loader";

export default function InvestorPortfolio() {

  const [investorTempList, setInvestorTempList] = useState([]);
  const [investorList, setInvestorList] = useState([]);
  let [loader, setLoader] = useState(1);

  const loadInvestorOverviewDetails = async () => {
    try {
      let response = await GetInvestorOverviewDetails();
      if (response?.status === 1) {
        setInvestorTempList(response?.responseValue);
        setInvestorList(response?.responseValue);
      }
      else {
        setInvestorTempList([]);
        setInvestorList([]);
      }
    }
    catch (e) {
      setInvestorTempList([]);
      setInvestorList([]);
    }
    finally {
      setLoader(0);
    }
  }

  useEffect(() => {
    loadInvestorOverviewDetails();
  }, []);

  return (
    <>
      <div className='container-fluid landformconatiner p-4'>
        <div className='d-flex flex-column flex-md-row justify-content-between'>
          <PageHeading pagename="Investors Portfolio Overview " />
          <FilterTable tempList={investorTempList} tempListMethod={setInvestorTempList} originalList={investorList} isSearch={true} />
        </div>
        <div className='pt-4'>
          <table className="table">
            <thead>
              <tr className='table-head'>
                <th scope="col">Name</th>
                <th scope="col">Total Land Area (SqFt)</th>
                <th scope="col">Investment Status (₹)</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody className='table-body'>
              {
                investorTempList && investorTempList.map((val, ind) => {
                  return (
                    <tr key={ind}>
                      <td>
                        <div className='d-flex flex-row gap-2'>
                          <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                          <span className='d-flex flex-column gap-1'>
                            <label className='heading-project fw-semibold'>{val.investorName}</label>
                          </span>
                        </div>
                      </td>
                      <td>{val.totalLandAreaSqFt}</td>
                      <td>
                        <span style={{ color: 'red', marginRight: '10px' }}>{val.investedAmount}</span>
                        <i className="fa-solid fa-arrow-down" style={{ color: 'red', marginRight: '20px' }}></i>
                        <span style={{ color: 'green', marginLeft: '10px' }}>{val.givenAmount}</span>
                        <i className="fa-solid fa-arrow-up" style={{ color: 'green', marginLeft: '5px' }}></i>
                      </td>
                      <td >
                        <div class="dropdown dropend">
                          <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                          <ul className="dropdown-menu mr-3">
                            <li><Link className="dropdown-item" to={`/investorproject/${val?.investorId}`}>View Details</Link></li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
      <Loader show={loader} />
    </>
  )
}
